/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { memo, useState } from "react";
import { Card, CardBody, Col, Button, Tooltip, Spinner } from "reactstrap";
import {
    MdInsertDriveFile,
    /* MdModeEdit, */
    // MdCreditCard
    MdAutorenew,
    MdNearMe,
} from "react-icons/md";
import DataTable from "../../../../shared/components/DataTable";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "react-confirm-alert/src/react-confirm-alert.css";
import CustomSearch from "./CustomSearch";
import { Link } from "react-router-dom";
import { permissionsConstants } from "../../../../constants/permissions.constants";
// import { appUtils } from "../../../../utils/app.utils";
import ModalComponent from "../../../../shared/components/Modal";
import Avatar from "react-avatar";
import ViewSingleBatchCustomer from "../../ViewSingleBatchCustomer";

const BatchCustomersTable = memo(({ dataState, fetchData, permissions, history, location, batchId, retryBulk, retryRequest, sendSucessfulCardOnly, completedBatch, showRetryButton, showSendSucesssFulButton, showResendButton }) => {
    const [searchKey, setSearchKey] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isSendToolTip, setSendToolTip] = useState(false);
    const [isRetryToolTip, setRetryToolTip] = useState(false);

    const sendSucessfultoggle = () => {
        setSendToolTip(!isSendToolTip);
    };

    const retryBatchtoggle = () => {
        setRetryToolTip(!isRetryToolTip);
    };

    const toggleModal = () => {
        setShowModal((prev) => !prev);
    };

    const count = dataState && dataState.response ? dataState.response.count : 0;

    const columns = [
        {
            accessor: "id",
            name: "",
            Cell: (row) => <Avatar round={true} size="32" name={`${row.firstName} ${row.lastName}`} />,
            sortable: true,
            sortKey: "id",
        },
        {
            accessor: "firstName",
            name: "First Name",
            sortable: true,
            sortKey: "FirstName",
        },
        {
            accessor: "lastName",
            name: "Last Name",
            sortable: true,
            sortKey: "LastName",
        },
        /*  {
        accessor: "dateOfBirth",
        name: "Date of Birth",
        sortable: true,
        sortKey: "dateOfBirth",
        Cell: row => appUtils.formatDOB(row.dateOfBirth)
      }, */
        {
            accessor: "emailAddress",
            name: "Email Address",
            sortable: true,
            sortKey: "emailAddress",
        },
        // {
        //   accessor: "domainCode",
        //   name: "Issuer",
        //   sortable: true,
        //   sortKey: "domainCode"
        // },
        {
            accessor: "mobileNo",
            name: "Mobile Number",
            sortable: true,
            sortKey: "mobileNo",
        },
        /* {
        accessor: "addressCity",
        name: "Address City",
        sortable: true,
        sortKey: "addressCity"
      },
      {
        accessor: "addressCountry",
        name: "Address Country",
        sortable: true,
        sortKey: "addressCountry"
      } */
    ];

    const sortFn = (page, pageSize, column) => {
        let sortOrder = "ASC";
        if (!dataState.loading) {
            if (dataState.request && dataState.request.sortOrder) {
                sortOrder = dataState.request.sortOrder === "ASC" ? "DESC" : "ASC";
            }
            fetchData({
                ...dataState.request,
                page,
                pageSize,
                sortKey: column.sortKey,
                sortOrder,
            });
        }
    };

    const handleAction = (row, action) => {
        if (action.name === "edit_customers") {
            history.push(`${location.pathname}/edit/${row.id}`);
        } else if (action.name === "view_customer") {
            toggleModal();
            setSelectedRow(row);
        } else if (action.name === "view_cards") {
            history.push(`/customers/cards`, { customerInfo: row });
        }
    };

    const handleSubmit = (values) => {
        setSearchKey(values.searchWord);
        fetchData({
            ...dataState.request,
            page: 1,
            searchWord: values.searchWord || "",
        });
    };

    const actions = [
        /* {
        name: "edit_customers",
        btnText: "Update Customer",
        btnAction: handleAction,
        btnClass: "default",
        btnIcon: MdModeEdit,
        permissions: []
      }, */
        {
            name: "view_customer",
            btnText: "View Customer",
            btnAction: handleAction,
            btnClass: "success",
            btnIcon: MdInsertDriveFile,
            permissions: [permissionsConstants.VIEW_CUSTOMER],
        },
        // {
        //   name: "view_cards",
        //   btnText: "View Cards",
        //   btnAction: handleAction,
        //   btnClass: "info",
        //   btnIcon: MdCreditCard,
        //   permissions: [permissionsConstants.VIEW_CUSTOMER_CARDS]
        // }
    ];

    const loadData = (page, pageSize) => {
        fetchData({
            ...dataState.request,
            page,
            pageSize,
            searchWord: searchKey,
        });
    };
    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">
                            Customers{" "}
                            {batchId && location.state && location.state.batchInfo ? (
                                <span>
                                    for request with Batch ID {batchId}{" "}
                                    <Link to="/card-requests" id="link-all-cardRequests">
                                        (Back to card requests)
                                    </Link>
                                </span>
                            ) : null}
                        </h5>
                        <div>
                            {showSendSucesssFulButton && (
                                <div>
                                    <Button className="btn btn-sm btn-outline-primary project-summary__btn mr-3" outline id="btn-refresh-cardrequests-sendButton" size="sm" onClick={completedBatch} style={{ right: "14rem", top: "3rem" }}>
                                        {sendSucessfulCardOnly.loading ? (
                                            <div style={{ width: "4rem" }}>
                                                <Spinner size="sm" />
                                            </div>
                                        ) : (
                                            <span>
                                                <MdNearMe size={20} style={{ fill: "#004266" }} /> Send
                                                <Tooltip placement="bottom" isOpen={isSendToolTip} target="btn-refresh-cardrequests-sendButton" toggle={sendSucessfultoggle} id="send">
                                                    Send Only Sucessful Cards in the Batch.
                                                </Tooltip>
                                            </span>
                                        )}
                                    </Button>
                                </div>
                            )}
                            {(showRetryButton || showResendButton) && (
                                <div>
                                    <Button className="btn btn-sm btn-outline-warning project-summary__btn" outline id="btn-refresh-cardrequests-retryButton" size="sm" onClick={retryBulk} style={{ right: "8rem", top: "3rem" }}>
                                        {retryRequest.loading ? (
                                            <div style={{ width: "3rem" }}>
                                                <Spinner size="sm" />
                                            </div>
                                        ) : (
                                            <span>
                                                <MdAutorenew size={20} style={{ fill: "yellow" }} /> {showResendButton ? "Resend" : "Retry"}
                                                <Tooltip placement="bottom" isOpen={isRetryToolTip} target="btn-refresh-cardrequests-retryButton" toggle={retryBatchtoggle} id="retryCard">
                                                    {showResendButton ? "Resend the batch again." : "Retry creating the entire batch again."}
                                                </Tooltip>
                                            </span>
                                        )}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                    <DataTable
                        columns={columns}
                        loading={dataState && dataState.loading}
                        data={dataState && dataState.response ? dataState.response.content : []}
                        permissions={permissions}
                        count={count}
                        countName="customers"
                        defaultPageSize={10}
                        defaultPageNumber={1}
                        loadData={loadData}
                        error={dataState && dataState.error}
                        bordered={true}
                        striped={true}
                        hover={true}
                        actions={actions}
                        customSearch={
                            <CustomSearch
                                pageNumer={1}
                                initialValues={{
                                    pageNumber: 1,
                                    pageSize: 10,
                                    searchKey: "",
                                }}
                                pageSize={10}
                                onSubmit={handleSubmit}
                            />
                        }
                        sortFn={sortFn}
                        searchKey={searchKey}
                        responsive
                        serverside
                    />
                </CardBody>
            </Card>
            <ModalComponent isOpen={showModal} toggle={toggleModal} size="lg">
                <ViewSingleBatchCustomer isModal selectedCustomer={selectedRow} />
            </ModalComponent>
        </Col>
    );
});

export default withRouter(
    connect((state) => ({
        permissions: state.permissions && state.permissions.response,
        toggleuser: state.toggleuser,
    }))(BatchCustomersTable)
);
